module.exports = __webpack_public_path__ + "static/media/close_secundary.4b5aebf7.svg";